<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Gift voucher payment</ion-title>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid class="large-inputs" style="width: 500px;" *ngIf="cart">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <ion-list>
                    <ion-item *ngIf="gift_voucher == undefined && person_gift_vouchers && person_gift_vouchers.length" lines="full">
                        <ion-select interface="alert" [interfaceOptions]="selectOptions" ok-text="Use" placeholder="Select" cancel-text="cancel" label="Customer vouchers" (ionChange)="setCode($event.detail.value)">
                            <ion-select-option *ngFor="let person_gift_voucher of person_gift_vouchers" value="{{person_gift_voucher.code}}">{{person_gift_voucher.code}} ({{person_gift_voucher.currency.sign}}{{person_gift_voucher.remaining_balance | number:'1.2'}} remaining)</ion-select-option>
                        </ion-select>
                    </ion-item>
                    <ion-item lines="full">
                        <ng-container *ngIf="gift_voucher != undefined">
                            <ion-label>Voucher code</ion-label>
                            {{gift_voucher.code}}
                        </ng-container>
                        <ion-input *ngIf="gift_voucher == undefined" #gift_voucher_code_input type="text" class="ion-text-right" inputmode="text" maxlength="20" class="ion-text-right" label="Voucher code" [(ngModel)]="gift_voucher_code"></ion-input>
                    </ion-item>
                    <ion-item *ngIf="gift_voucher != undefined" lines="full">
                        <ion-label>Voucher balance</ion-label>
                        {{gift_voucher.currency.sign}}{{gift_voucher.remaining_balance | number:'1.2'}}
                    </ion-item>
                    <ion-item *ngIf="gift_voucher != undefined" lines="full">
                        <ion-label>Amount due</ion-label>
                        {{cart.currency.sign}}{{cart.amount_due | number:'1.2'}}
                    </ion-item>
                    <ion-item *ngIf="gift_voucher != undefined" lines="full">
                        <ion-input type="tel" class="ion-text-right" inputmode="decimal" maxlength="10" label="Amount to charge" [(ngModel)]="payment_amount" (ngModelChange)="sanitisePaymentAmount()"></ion-input>
                    </ion-item>
                    <ion-item *ngIf="gift_voucher == undefined" button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="validateCode()">
                        <ion-label>FIND VOUCHER</ion-label>
                    </ion-item>
                    <ion-item *ngIf="gift_voucher != undefined && payment.price > 0" button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="addPayment()">
                        <ion-label>ADD PAYMENT</ion-label>
                    </ion-item>
                </ion-list>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>